<template>
  <v-menu
    v-model="calendarOpen"
    offset-y
    :close-on-content-click="false"
    min-width="280"
    content-class="dayPicker"
  >
    <template #activator="{ on }">
      <div
        v-ripple
        class="dayPicker_day"
        :class="{
          'dayPicker_day-open': calendarOpen,
          'dayPicker_day-active': active,
        }"
        v-on="on"
      >
        <div class="dayPicker_select">
          <span class="dayPicker_icon icon icon-calendar" />
          <span class="dayPicker_date">{{
            day | date('YYYY/M/D', 'YYYYMMDDHHmmss')
          }}</span>
        </div>
      </div>
    </template>
    <date-picker
      v-model="currentDay"
      locale="ja"
      mode="date"
      :masks="masks"
      :min-date="minDate"
      :max-date="maxDate"
      is24hr
      is-expanded
    />
    <span class="dayPicker_label">今日</span>
    <div class="dayPicker_actions">
      <div class="dayPicker_action">
        <v-btn
          text
          class="dayPicker_btn dayPicker_btn-cancel"
          @click="calendarOpen = false"
        >
          キャンセル
        </v-btn>
      </div>
      <div class="dayPicker_action">
        <v-btn text class="dayPicker_btn dayPicker_btn-ok" @click="submit">
          設定
        </v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script>
import DatePicker from 'v-calendar/src/components/DatePicker.vue';

export default {
  name: 'DayPicker',
  components: { DatePicker },
  props: {
    day: {
      type: Date,
      default: () => new Date(),
    },
    active: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: () => null,
    },
    maxDate: {
      type: Date,
      default: () => null,
    },
  },
  data() {
    return {
      masks: {
        data: 'YYYY/M/DD hh:mm:00',
        inputDateTime: 'YYYY/M/DD hh:mm:00',
        iso: 'YYYY/M/DD hh:mm:00',
        input: 'YYYY-MM-DD',
        inputDateTime24hr: 'YYYY-MM-DD HH:mm',
        navMonths: 'MM',
        title: 'YYYY/M',
      },
      currentDay: this.day,
      calendarOpen: false,
    };
  },
  watch: {
    day: {
      immediate: true,
      handler(newDay) {
        this.currentDay = newDay;
      },
    },
  },
  created() {},
  methods: {
    submit() {
      this.calendarOpen = false;
      this.$emit('update:day', this.currentDay);
    },
  },
};
</script>

<style lang="scss">
.dayPicker {
  background-color: #fff;
  &_label {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.08;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
    border: solid 2px #e0e0e0;
    border-radius: 5px;
    padding: 1px 10px;
    position: absolute;
    top: 16px;
    right: 7px;
  }
  &_day {
    display: flex;
    color: #666;
    border-radius: 5px;
    flex-wrap: wrap;
    &-open {
      background-color: #eeeeee;
    }
    &-active {
      color: var(--v-primary-base);
    }
  }
  &_select {
    display: flex;
    align-items: center;
    height: 20px;
    margin: 3px;
    cursor: pointer;
  }
  &_date {
    display: flex;
    width: 80px;
    font-size: 14px;
    font-weight: 400;
    padding-left: 6px;
  }
  &_time {
    display: flex;
    width: 70px;
    font-size: 14px;
    font-weight: 400;
    padding-left: 5px;
  }
  &_separator {
    display: flex;
    height: 20px;
    line-height: 20px;
    margin-top: 3px;
  }
  .vc-container {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  &_actions {
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
  }
  &_action {
    display: flex;
    justify-content: center;
    width: 50%;
  }
  &_btn {
    .v-btn__content {
      font-size: 14px;
      font-weight: bold;
    }
    &-cancel {
      .v-btn__content {
        color: #0075c2;
      }
    }
  }
}
</style>
